<div class="side-nav-menu menu-items-wrapper">
  <div class="logo-wrapper">
    <a class="" href="/">
      <img alt="Guru Granth Sahib Logo" src="/assets/images/logo.webp" />
    </a>
  </div>
  <nav class="menu">
    <div class="toggle-options-wrapper">
      <span>
        <button id="languageHandset" (click)="onSelectLanguage(fetchLanguage() === 'en' ? 'pa' : 'en')"
          class="select-language-button" mat-button>
          {{ fetchLanguage() !== "en" ? "English" : "panjabi" | translate }}
        </button>
      </span>
      <span>&nbsp;&nbsp;</span>
      <span>
        <button id="donate" style="position: relative;left: 2px;" class="select-donate-button" (click)="onDonateClick()"
          mat-button>
          {{ fetchLanguage() == "en" ? "Donate" : "Donate" | translate }}
        </button>
      </span>

    </div>
    <ul class="menu-items">
      <li class="menu-item has-submenu" id="GuruSahibHandset">
        <span class="menu-item-actionable">
          {{ "ggs" | translate }}<mat-icon>arrow_drop_down</mat-icon>
        </span>

        <ul class="submenu">
          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/guru-granth-sahib' : '/info/english/guru-granth-sahib'">{{
              "What is the Guru Granth Sahib?" | translate }}</a></li>
          <li class="submenu-item"><a class="header-menu-item-mobile" href="/search">{{ "Compositions" | translate
              }}</a></li>
        </ul>
      </li>

      <li class="menu-item"><a class="header-menu-item-mobile" target="_blank"
          href="https://gurugranthsahibdictionary.io">{{ "dictionary" | translate }}</a></li>

      <li class="menu-item has-submenu" id="projectHandset">
        <span class="menu-item-actionable">
          {{ "project" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </span>
        <ul class="submenu">
          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/approach' : '/info/english/approach'">{{ "approach" |
              translate }}</a></li>
          <li class="submenu-item">
            <a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/methodology' : '/info/english/methodology'">{{
              "Methodology" | translate }}</a>
          </li>
          <li class="submenu-item"><a class="header-menu-item-mobile" href="/glossary">{{ "glossary" | translate }}</a>
          </li>
          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/navigation' : '/info/english/navigation'">{{ "Navigation"
              | translate }}</a></li>
          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/bibliography' : '/info/english/bibliography'">{{
              "bibliography" | translate }}</a></li>
          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/project' : '/info/english/project'" target="_blank"> {{
              "initiative" | translate }}</a></li>
          <!-- <li class="submenu-item"><a class="header-menu-item-mobile" [href]="fetchLanguage() != 'en' ? '/info/panjabi/project' : '/info/english/project'">{{ "Project" | translate }}</a></li> -->
        </ul>
      </li>
      <li class="menu-item has-submenu">
        <span class="menu-item-actionable">
          {{ "About Us" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </span>
        <ul class="submenu">

          <li class="submenu-item"><a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/team' : '/info/english/team'">{{ "team" | translate
              }}</a></li>
          <!-- <li (click)="goToPage('news')" class="submenu-item">{{ "News" | translate }}</li>
          <li (click)="goToPage('articles')" class="submenu-item">{{ "Articles" | translate }}</li>
          <li (click)="goToPage('press-releases')" class="submenu-item">{{ "Press Releases" | translate }}</li> -->
          <li class="submenu-item">
            <a class="header-menu-item-mobile" href="https://jobs.sikhri.org" target="_blank">{{ "Careers" | translate
              }}</a>
          </li>
          <!--   <li class="submenu-item">
             <a class="header-menu-item-mobile" href="https://sikhri.org/donate" target="_blank">{{ "Donate" | translate }}</a>
          </li> -->
          <li class="submenu-item">
            <!--  <a class="header-menu-item-mobile" href="https://docs.google.com/forms/d/e/1FAIpQLScxrzYSIPoGu7jyez8akLsrfFEbdlVBKAkciI3hTiyIMJAP3Q/viewform" target="_blank">{{ "Feedback" | translate }}</a> -->
            <a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/contact-us' : '/info/english/contact-us'"> {{ "Contact Us" | translate }} </a>
          </li>
          <!-- <li class="submenu-item">
            <a class="header-menu-item-mobile"
              [href]="fetchLanguage() != 'en' ? '/info/panjabi/articles' : '/info/english/articles'"> {{ "Articles" |
              translate }} </a>
          </li> -->
        </ul>
      </li>
      <!-- <li class="menu-item"><a class="header-menu-item-mobile" [href]="fetchLanguage() != 'en' ? '/info/panjabi/contact-us' : '/info/english/contact-us'"> {{ "Subscribe" | translate }} </a></li> -->

    </ul>
  </nav>
</div>